import { createFileRoute } from '@tanstack/react-router';
import EntitiesPage from '@/pages/setup/entities/EntitiesPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface EntitiesSearch {
  id?: string;
  type?: string;
}

export const Route = createFileRoute('/_authenticated/setup/entities')({
  beforeLoad: () => requireSetupPageAccess('/setup/entities'),
  validateSearch: (raw: Record<string, unknown>): EntitiesSearch => ({
    id: (raw.id as string) ?? undefined,
    type: (raw.type as string) ?? undefined,
  }),
  component: EntitiesPage,
});
